import { AuthenticationService } from '../services/general';
import type { LoginRequest } from '../services/general';

export const checkAuth = () => {
  return AuthenticationService.readUsersMeApiAuthMeGet();
};

export const performLogout = () => {
  return AuthenticationService.logoutApiAuthLogoutPost();
};

export const performLogin = (payload: LoginRequest) => {
  return AuthenticationService.loginApiAuthLoginPost(payload);
};

export type { LoginRequest } from '../services/general';
